import Service from "../../services";

const statusModule = {
    namespaced: true,
    state: { list: [] },
    mutations: {
        SET_ALL: (state, data) => {
            state.list = data;
        }
    },
    actions: {
        setAll({ commit }) {
            Service.status.getAllStatus().then(res => {
                commit("SET_ALL", res);
            });
        }
    },
    getters: {
        getAll(state) {
            return state.list;
        }
    }
};
export default statusModule;